export default __webpack_public_path__ + "static/media/05_Confessions.5c7caaef.jpg";